import { menuGroup, menuItem } from "modules/helpers";
import FormValidation from "./FormValidation.doc";
import FormVirtualization from "./FormVirtualization.doc";

// standard components
import Form from "./Form.doc";
import FormArray from "./FormArray.doc";
import FormArrayAction from "./FormArrayAction.doc";
import FormArrayAdder from "./FormArrayAdder.doc";
import FormArrayRemover from "./FormArrayRemover.doc";
import FormArrayTable from "./FormArrayTable.doc";
import FormClearer from "./FormClearer.doc";
import FormCustomErrors from "./FormCustomErrors.doc";
import FormField from "./FormField.doc";
import FormGroup from "./FormGroup.doc";
import FormIf from "./FormIf.doc";
import FormLabel from "./FormLabel.doc";
import FormObject from "./FormObject.doc";
import FormTrigger from "./FormTrigger.doc";

const standardComponents = [
  menuItem("<Form/>", "form", Form),
  menuItem("<Form.Array/>", "form-array", FormArray),
  menuItem("<Form.ArrayAction/>", "form-array-action", FormArrayAction),
  menuItem("<Form.ArrayAdder/>", "form-array-adder", FormArrayAdder),
  menuItem("<Form.ArrayRemover/>", "form-array-remover", FormArrayRemover),
  menuItem("<Form.ArrayTable/>", "form-array-table", FormArrayTable),
  menuItem("<Form.Clearer/>", "form-clearer", FormClearer),
  menuItem("<Form.CustomErrors/>", "form-custom-errors", FormCustomErrors),
  menuItem("<Form.Field/>", "form-field", FormField),
  menuItem("<Form.Group/>", "form-group", FormGroup),
  menuItem("<Form.If/>", "form-if", FormIf),
  menuItem("<Form.Label/>", "form-label", FormLabel),
  menuItem("<Form.Object/>", "form-object", FormObject),
  menuItem("<Form.Trigger/>", "form-trigger", FormTrigger),
];

// field components
import FormCheckbox from "./FormCheckbox.doc";
import FormCheckboxGroup from "./FormCheckboxGroup.doc";
import FormCheckboxTree from "./FormCheckboxTree.doc";
import FormDate from "./FormDate.doc";
import FormDateTime from "./FormDateTime.doc";
import FormDropdown from "./FormDropdown.doc";
import FormEmail from "./FormEmail.doc";
import FormInput from "./FormInput.doc";
import FormMonth from "./FormMonth.doc";
import FormNumeric from "./FormNumeric.doc";
import FormPassword from "./FormPassword.doc";
import FormRadioGroup from "./FormRadioGroup.doc";
import FormRating from "./FormRating.doc";
import FormSwitch from "./FormSwitch.doc";
import FormTextArea from "./FormTextArea.doc";
import FormTime from "./FormTime.doc";
import FormTypeAhead from "./FormTypeAhead.doc";
import FormUrl from "./FormUrl.doc";
import FormYear from "./FormYear.doc";

const fieldComponents = [
  menuItem("<Form.Checkbox/>", "form-checkbox", FormCheckbox),
  menuItem("<Form.CheckboxGroup/>", "form-checkbox-group", FormCheckboxGroup),
  menuItem("<Form.CheckboxTree/>", "form-checkbox-tree", FormCheckboxTree),
  menuItem("<Form.Date/>", "form-date", FormDate),
  menuItem("<Form.DateTime/>", "form-date-time", FormDateTime),
  menuItem("<Form.Dropdown/>", "form-dropdown", FormDropdown),
  menuItem("<Form.Email/>", "form-email", FormEmail),
  menuItem("<Form.Input/>", "form-input", FormInput),
  menuItem("<Form.Month/>", "form-month", FormMonth),
  menuItem("<Form.Numeric/>", "form-numeric", FormNumeric),
  menuItem("<Form.Password/>", "form-password", FormPassword),
  menuItem("<Form.RadioGroup/>", "form-radio-group", FormRadioGroup),
  menuItem("<Form.Rating/>", "form-rating", FormRating),
  menuItem("<Form.Switch/>", "form-switch", FormSwitch),
  menuItem("<Form.TextArea/>", "form-text-area", FormTextArea),
  menuItem("<Form.Time/>", "form-time", FormTime),
  menuItem("<Form.TypeAhead/>", "form-type-ahead", FormTypeAhead),
  menuItem("<Form.Url/>", "form-url", FormUrl),
  menuItem("<Form.Year/>", "form-year", FormYear),
];

// extended components
import FormFile from "./FormFile.doc";
import FormHtml from "./FormHtml.doc";

const extendedComponents = [
  menuItem("<FormFile/>", "form-file", FormFile),
  menuItem("<FormHtml/>", "form-html", FormHtml),
];

// hooks
import UseFormEffect from "./UseFormEffect.doc";
import UseFormError from "./UseFormError.doc";
import UseFormField from "./UseFormField.doc";
import UseFormState from "./UseFormState.doc";

const hooks = [
  menuItem("useFormEffect", "use-form-effect", UseFormEffect),
  menuItem("useFormError", "use-form-error", UseFormError),
  menuItem("useFormField", "use-form-field", UseFormField),
  menuItem("useFormState", "use-form-state", UseFormState),
];

export default [
  menuItem("Form Validation", "form-validation", FormValidation),
  menuItem("Form Virtualization", "form-virtualization", FormVirtualization),
  menuGroup("Standard Components", "standard-components", standardComponents),
  menuGroup("Field Components", "field-components", fieldComponents),
  menuGroup("Extended Components", "extended-components", extendedComponents),
  menuGroup("Hooks", "hooks", hooks),
];
